module.exports = __webpack_public_path__ + "img/Androiddownload.1d871023.png";